module.exports = __webpack_public_path__ + "img/dstv.58c1e925.svg";